module.exports = __webpack_public_path__ + "static/media/ContactIcon.a3355e76.svg";